import React from "react";
import { format, formatInTimeZone } from "date-fns-tz";

export function formatBusinessNumber(number) {
    if (!number) {
        return "";
    }
    const cleaned = ('' + number).replace(/\D/g, '');
    const match = cleaned.match(/^(\d{3})(\d{2})(\d{5})$/);
    if (match) {
        return `${match[1]}-${match[2]}-${match[3]}`;
    }
    return number; // 형식이 맞지 않으면 원래 번호 반환
}

export function formatPhoneNumber(number) {
    if (!number) {
        return "";
    }
    const cleaned = ('' + number).replace(/\D/g, '');
    const match = cleaned.match(/^(\d{3})(\d{4})(\d{4})$/);
    if (match) {
        return `${match[1]}-${match[2]}-${match[3]}`;
    }
    return number;
}

export function formatCurrency(number) {
    if (!number) {
        return "";
    }

    return number.toLocaleString('ko-KR');
}

export function formatDate(date, formatString = 'yyyy-MM-dd HH:mm') {
    if (!date) {
        return date;
    }
    return format(date, formatString, { timeZone: 'Asia/Seoul' });
}

export function formatDateParam(date, formatString = "yyyy-MM-dd'T'HH:mm:ss") {
    if (!date) {
        return date;
    }
    return formatInTimeZone(date, 'Asia/Seoul', formatString)
}

export function formatPrice(price) {
    return price?.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
}

export function displayMembershipStatus(membershipStatus) {
    switch (membershipStatus) {
        case "UNSUBSCRIBE": return <span style={{color: "gray"}}>미구독</span>
        case "SUBSCRIBE": return <span style={{color: "blue"}}>구독중</span>
        case "SUBSCRIBE_HOLD": return <span style={{color: "red"}}>구독보류</span>
        case "SUBSCRIBE_CANCEL": return <span style={{color: "red"}}>구독취소요청중</span>
        default: return <span style={{color: "gray"}}>미구독</span>
    }
}